export default "__VITE_ASSET__DZLor5Co__"